import UserBioCard from '../components/UserBioCard'
import SEO from '../components/SEO'
import ScrollToTop from '../components/ScrollToTop'
import team from '../team-data/team'

const TeamPage = () => {
  // Get all team member keys from the team data
  const teamMembers = Object.keys(team);

  return (
    <>
      <SEO 
        title="WeFlare Team"
        description="Meet our team" 
        keywords="WeFlare team, Youth Leaders Kenya, Youth Advocates Kenya, Vivian Njambi, Alex Mavuti, Kiyo Mwangi"
        url="https://weflare.org/team"
      />
      <ScrollToTop />
      <div className="bg-pattern-light py-3">
        <div class="container page-length">
        <div className="row justify-content-center">
          <div className="col-12">
            <h1 className="text1 text-center">Meet Our Team</h1>
          </div>
          {teamMembers.map((memberSlug) => (
            <div key={memberSlug} className="col-sm-12 col-md-3 col-lg-3 mt-3">
              <UserBioCard
                userSlug={memberSlug}
                styleImage={{objectFit: 'cover'}} 
              />
            </div>
          ))}
        </div>
      </div>
      </div>
    </>
  )
}

export default TeamPage